<div class="notifications-panel-container">
  <header class="panel-header">
    <span class="panel-title">{{ "NOTIFICATIONS.PANEL.TITLE" | translate }}</span>

    <div class="flex items-center gap-1">
      <button mat-button type="button" class="mark-all-button" [disabled]="isLoading()" (click)="markAllAsRead()">
        {{ "NOTIFICATIONS.PANEL.MARK_ALL_AS_READ" | translate }}
        <mat-icon iconPositionEnd>check</mat-icon>
      </button>

      <button
        mat-icon-button
        type="button"
        [attr.aria-label]="'NOTIFICATIONS.PANEL.CLOSE_ARIA' | translate"
        (click)="onClosePanel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="panel-filters text-sm">
    <mat-slide-toggle [checked]="unreadOnly()" [disabled]="isLoading()" (change)="onUnreadOnlyChange($event.checked)">
      {{ "NOTIFICATIONS.PANEL.SHOW_UNREAD_ONLY" | translate }}
    </mat-slide-toggle>
  </div>

  <div class="list-container">
    @if (isLoading()) {
      <div class="loading-indicator">
        <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="40"></mat-progress-spinner>
      </div>
    } @else if (notifications().length) {
      @for (item of notifications(); track item.id) {
        <under-ui-notification-item
          [notification]="item"
          (markAsRead)="onMarkAsRead($event)"
          (executeAction)="onExecuteAction($event)">
        </under-ui-notification-item>
      }
    } @else {
      <div class="empty-state">
        <div class="empty-state-content">
          <h3 class="empty-state-title">
            {{ (unreadOnly() ? "NOTIFICATIONS.EMPTY.UNREAD_TITLE" : "NOTIFICATIONS.EMPTY.TITLE") | translate }}
          </h3>
          <p class="empty-state-subtitle">
            {{ (unreadOnly() ? "NOTIFICATIONS.EMPTY.UNREAD_SUBTITLE" : "NOTIFICATIONS.EMPTY.SUBTITLE") | translate }}
          </p>
        </div>
      </div>
    }
  </div>

  <footer class="panel-footer">
    <mat-paginator
      [length]="totalCount()"
      [pageSize]="pageSize()"
      [pageIndex]="pageIndex()"
      [pageSizeOptions]="pageSizeOptions"
      (page)="handlePageEvent($event)"
      [disabled]="isLoading()"
      showFirstLastButtons
      [attr.aria-label]="'NOTIFICATIONS.PANEL.PAGINATOR_ARIA' | translate">
    </mat-paginator>
  </footer>
</div>
